module.exports = __webpack_public_path__ + "img/Flag_of_the_Northern_Mariana_Islands.427ae859.svg";